export default [
    {
        path: '/choose-role',
        name: 'choose-role',
        component: () => import('@/Pages/Auth/Role.vue'),
        meta: { layout: 'AuthLayout' }
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('@/Pages/Auth/Login.vue'),
        meta: { layout: 'AuthLayout' }
    },
    {
        path: '/login-retry',
        name: 'login-retry',
        component: () => import('@/Pages/Auth/LoginRetry.vue'),
        meta: { layout: 'AuthLayout' }
    },
    {
        path: '/logout',
        name: 'logout',
        component: () => import('@/Pages/Auth/Logout.vue'),
        meta: { layout: 'AuthLayout' }
    },
    {
        path: '/auth/callback',
        name: 'callback',
        component: () => import('@/Pages/Auth/Callback.vue'),
        meta: { layout: 'AuthLayout' }
    },
    {
        path: '/register',
        name: 'register',
        component: () => import('@/Pages/Auth/Register.vue'),
        meta: {
            layout: 'AuthLayout',
            containerClass: "col-12 col-sm-11 col-md-10 col-lg-9 col-xl-8",
        }
    },
    {
        path: '/registration-status',
        name: 'registration-status',
        component: () => import('@/Pages/Auth/Status/RegistrationStatus.vue'),
        meta: {
            layout: 'AuthLayout',
        }
    },
    {
        path: '/registration-detail',
        name: 'registration-detail',
        component: () => import('@/Pages/Auth/Status/DetailRegistrationStatus.vue'),
        meta: {
            layout: 'AuthLayout',
            isHideLogo: true
        }
    },
    {
        path: '/forgot-password',
        name: 'forgot-password',
        component: () => import('@/Pages/Auth/Register.vue'),
        meta: { layout: 'AuthLayout' }
    },
    {
        path: '/create-password',
        name: 'create-password',
        component: () => import('@/Pages/Auth/Status/_partials/CreatePassword.vue'),
        meta: { layout: 'AuthLayout' }
    },
    {
        path: '/account-registered',
        name: 'account-registered',
        component: () => import('@/Pages/Auth/Status/_partials/AccountRegistered.vue'),
        meta: { layout: 'AuthLayout' }
    },
]
